import { handleActions } from 'redux-actions'

import { actions } from '../actions/messages'

const defaultState = {
    message: undefined
}

const clearMessage = (state, _action) => {
    return { ...state, message: undefined }
}

const showMessage = (state, action) => {
    return { ...state, message: action.payload }
}

export default handleActions({
    [actions.clearMessage]: clearMessage,
    [actions.showMessage]: showMessage
}, defaultState)



// WEBPACK FOOTER //
// ./src/store/reducers/messages.js